import {ProductBase} from '../../models/product.model';
import {ValidationError} from '../../models/validation-error.model';
import {ProductPg} from '../../models/product-pg.model';
import {ValidationUploadFileErrors} from '../../models/validation-upload-file-errors';

export namespace ProductPgActions {
    export class GetOne {
        static readonly type = 'ProductPgActions.GetOne';

        constructor(public id: number) {
        }
    }

    export class Duplicate {
        static readonly type = 'ProductPgActions.Duplicate';

        constructor(public id: number, public data: ProductBase) {
        }
    }

    export class Update {
        static readonly type = 'ProductPgActions.Update';

        constructor(public readonly product: ProductPg) {
        }
    }

    export class Merge {
        static readonly type = 'ProductPgActions.Merge';

        constructor(public readonly product: ProductPg) {
        }
    }

    export class FormFailure {
        static readonly type = 'ProductPgActions.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class MergeFailure {
        static readonly type = 'ProductPgActions.MergeFailure';

        constructor(public readonly uploadFileErrors: ValidationUploadFileErrors[]) {
        }
    }

    export class Clear {
        static readonly type = 'ProductPgActions.Clear';
    }

    export class ClearValidationErrors {
        static readonly type = 'ProductPgActions.ClearValidationErrors';

        constructor(public readonly fields: string[] = []) {
        }
    }

    export class ClearFileValidationErrors {
        static readonly type = 'ProductPgActions.ClearFileValidationErrors';
    }

    export class DownloadFile {
        static readonly type = 'ProductPgActions.DownloadFile';

        constructor(public hash: string) {
        }
    }

    export class PolicyTemplatesList {
        static readonly type = 'ProductPgActions.PolicyTemplatesList';
    }

    export class AvailableStatusesList {
        static readonly type = 'ProductPgActions.AvailableStatusesList';

        constructor(public id: number) {
        }
    }
}
